import React from 'react';

export const PilgrimageSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path fill="currentColor"
                  d="M51.36 2C45.5 2 40.72 6.77 40.72 12.64c0 4.41 5.84 12.36 8.55 15.8h-15.5c-4.17 0-6.75 2.95-7.46 5.87-.7 2.92.24 6.72 3.95 8.63l18.95 9.75c2 1.02 2.32 2.98 1.99 4.35S49.69 60 47.44 60H14.72c2.71-3.43 8.56-11.38 8.56-15.81 0-5.86-4.78-10.63-10.64-10.63S2 38.33 2 44.19c0 5.63 9.47 16.97 9.87 17.45a.992.992 0 001.01.33c.07.02.15.03.23.03h34.33c3.19 0 5.16-2.25 5.7-4.49.55-2.24-.18-5.14-3.02-6.6l-18.95-9.75c-2.92-1.51-3.4-4.38-2.91-6.38.48-2 2.21-4.34 5.51-4.34h17.59c.14 0 .27-.03.39-.08a.7.7 0 00.17-.09c.04-.03.08-.06.12-.1.01-.01.02-.02.04-.03.03-.04.07-.08.11-.13V30C53.18 28.82 62 18.06 62 12.64 62 6.77 57.23 2 51.36 2zM12.64 49.36c-2.85 0-5.17-2.32-5.17-5.17s2.32-5.16 5.17-5.16 5.16 2.32 5.16 5.16-2.31 5.17-5.16 5.17zM51.36 17.8c-2.85 0-5.16-2.31-5.16-5.16s2.31-5.17 5.16-5.17 5.17 2.32 5.17 5.17-2.32 5.16-5.17 5.16z"/>
        </svg>
    )
};
